/* eslint no-console: 0 */
/* global axios */

class ApiClient {
  constructor(resource, options = {}) {
    this.resource = resource;
    this.options = options;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    if (!window.location.pathname.includes('/app/accounts')) return '';
    return window.location.pathname.split('/')[3] || '';
  }

  get url() {
    let url = `/api/v1/${this.resource}`;

    if (this.options.accountScoped) {
      const accountId = this.options.accountId || this.accountIdFromRoute;
      if (accountId) {
        url = `/api/v1/accounts/${accountId}/${this.resource}`;
      }
    }

    return url;
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default ApiClient;
